import { FormControlLabel, Grid, MenuItem, Select, SelectChangeEvent, Stack, Switch } from '@mui/material';
import { useLayoutEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import RangeSelectorDatetime from '../common/RangeSelectorDatetime';
import moment, { Moment } from 'moment';
import { useGetFilteredTasksMutation } from '../../services/analytics.service';
import { ApexOptions } from 'apexcharts';

const chartStyle = {
  height: '100%',
  width: '100%',
  flexDirection: 'column',
  bgcolor: '#ffffff',
  border: '1px solid #E2E8F0',
  borderRadius: '8px',
  p: 2,
};

const groupByList = ['status', 'urgency'];

function TasksDonut() {
  const [showLegend, setShowLegend] = useState(false);
  const [getTasks] = useGetFilteredTasksMutation();
  const [chartData, setChartData] = useState<ApexOptions>({ series: [], labels: [] });
  const [groupBy, setGroupBy] = useState('status');
  const [pipeline, setPipeline] = useState({
    ranges: [{ field: 'createdAt', start: moment().subtract(2, 'months'), end: moment() }],
    dynamicFilters: [],
    groupOptions: { groupByField: groupBy },
  });

  useLayoutEffect(() => {
    getData(pipeline);
  }, [pipeline]);

  const handleRangeChange = (range: { start: Moment | null; end: Moment | null }) => {
    setPipeline({
      ...pipeline,
      ranges: [{ field: 'createdAt', start: range.start?.toISOString() as any, end: range.end?.toISOString() as any }],
    });
  };

  const handleChangeGroup = (e: SelectChangeEvent) => {
    const value = e.target.value;
    setGroupBy(value);
    setPipeline({ ...pipeline, groupOptions: { groupByField: value } });
  };

  const getData = (p: any) => {
    getTasks(p).then((res: any) => {
      const data = res?.data;
      if (data?.length > 0) {
        setChartData({
          ...chartData,
          series: data.map((item: any) => item.count ?? 0),
          labels: data.map((item: any) => item._id ?? ''),
        });
      }
    });
  };

  return (
    <Grid item container flex={1} sx={chartStyle}>
      <Grid item container gap={1}>
        <RangeSelectorDatetime onRangeChange={handleRangeChange} />
        <Stack direction="row" width="100%" spacing={1}>
          <Select
            fullWidth
            size="small"
            value={groupBy}
            sx={{ textTransform: 'capitalize' }}
            onChange={handleChangeGroup}>
            {groupByList.map((g) => (
              <MenuItem sx={{ textTransform: 'capitalize' }} key={g} value={g}>{g}</MenuItem>
            ))}
          </Select>
          <FormControlLabel
            control={<Switch size="small" checked={showLegend} onChange={(e) => setShowLegend(e.target.checked)} />}
            label="Legend"
          />
        </Stack>
      </Grid>
      <Grid item sx={{ flex: 1, minHeight: 0 }}>
        <Chart
          options={{ ...chartData, legend: { show: showLegend } }}
          series={chartData.series}
          type="pie"
          height={300}
        />
      </Grid>
    </Grid>
  );
}

export default TasksDonut;
